const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const getIPaddress = require('@dbk-legacy/wso2token').getIPaddress;
const SEPERATOR = require('../../utils/constants');
const apiConfig = require('../../api-config');
const { Base64 } = require('js-base64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {

    startRMSession(inputParam, metaData) {
      const url = getUrl('initiate-session');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const userId = params[0];
      const selectedContractId = params[1];

      const body = {
        userId: userId,
        selectedContractId: selectedContractId
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    getContractsList(inputParam, metaData) {
      const url = getUrl('getcontracts');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true,
      };

      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const adminUserId = params[0];
      const bpId = params[1];
      const contractId = params[2];

      const body = {
        adminUserId: adminUserId,
        criteria: {
          bpId: bpId,
          contractId: contractId
        }
      }

      return requestHandler(merge(reqOpts, {
        url,
        body,
      }));
    },

    rmSessionLogout(inputParam, metaData) {
      const url = getUrl('rm-client-session-logout');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const decodedRequest = JSON.parse(Base64.decode(inputParam));
      const body = {
        userId: decodedRequest.userId,
        ipAddress: getIPaddress()
      }
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    rmLogout(metaData){
      const url = getUrl('rmlogout');
      const parsedMetaData = parseRequestMetaData(metaData);

      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const body = {
        userId: parsedMetaData.qs.userId
      }

      return requestHandler(merge(reqOpts, {
        url,
        body,
      }));
    }
  };
}


module.exports = apiFactory;
